import { useEffect } from 'react';
import {useLocation} from 'react-router-dom'

export function useTitle(name = 'title') {
    useEffect(() => {
        document.title = name
    }, [name])
}
export function useUrlQuery() {
    let searchObj = {}
    let {search} = useLocation()
    if (search) {
        let _searchObj = {}
        search.slice(1).split('&').forEach(item => {
            let [key, value] = item.split("=")
            if (key === undefined || value === undefined) return
            _searchObj[key] = value
        })
        if (Object.keys(_searchObj).length) {
            searchObj = _searchObj
        }
    }
    return searchObj
}